const displayINRCurrency = (num) => {
    const formatter = new Intl.NumberFormat('en-LY', {
        style: 'currency',
        currency: 'LYD',
        minimumFractionDigits: 2
    })

        // Check if the number is negative
        if (num < 0) {
            // Return the absolute value and append the custom text
            return `${formatter.format(Math.abs(num))} (لدى المستخدم بالمحفظة)`;
        }

    return formatter.format(num)

}

export default displayINRCurrency



